import { Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import Services from "./pages/Services";
import DoorsWindows from "./pages/services/DoorsWindows";
import TerracesOutdoor from "./pages/services/TerracesOutdoor";
import IndoorRenovation from "./pages/services/IndoorRenovation";
import Gallery from "./pages/Gallery";
import About from "./pages/About";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import Forbidden from "./pages/Forbidden";

export default function App() {
  return (
    <HelmetProvider>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-[#FAFAF8] text-[#111111]">
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/ydelser" element={<Services />} />
            <Route path="/ydelser/doere-og-vinduer" element={<DoorsWindows />} />
            <Route path="/ydelser/traeterrasser-og-udendoersarealer" element={<TerracesOutdoor />} />
            <Route path="/ydelser/indendoers-renovering" element={<IndoorRenovation />} />
            {/* Backward compatibility redirects / aliases */}
            <Route path="/ydelser/bindingsvaerk" element={<TerracesOutdoor />} />
            <Route path="/ydelser/tagarbejde" element={<IndoorRenovation />} />
            <Route path="/galleri" element={<Gallery />} />
            <Route path="/om-andreas" element={<About />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/403" element={<Forbidden />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </HelmetProvider>
  );
}
